import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import Draggable from 'react-draggable'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import isEqual from 'lodash-es/isEqual'
import * as VideoPlayerActions from '../../actions/videoActions'

// Torch this code with gasoline at the earliest opportunity

const DRAGGABLE_DEFAULT_POSITION = { x: 0, y: 0 }

const Style = {
    mobile: {
        volumeBarContainer: volumeHeight => ({
            width: 50,
            height: volumeHeight + 36,
            borderRadius: 4,
            zIndex: 800,
            background: styleguide.colors['transparentBlack'],
        }),

        volume: volumeHeight => ({
            background: styleguide.colors['white'],
            width: 10,
            height: volumeHeight + 6,
            left: 20,
            top: 18,
            position: 'relative',
            cursor: 'pointer',
        }),

        bar: percent => ({
            position: 'absolute',
            width: '100%',
            height: '100%',
            transform: `scale(1, ${percent})`,
            transformOrigin: 'bottom left',
            bottom: 0,
            background: styleguide.colors['teal'],
        }),

        marker: {
            position: 'relative',
            left: 14,
            cursor: 'pointer',
            background: styleguide.colors['white'],
            width: 22,
            height: 22,
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
            ...styleguide.rounded,
        },
    },

    desktop: {
        volumeBarContainer: volumeHeight => ({
            width: 30,
            height: volumeHeight + 36,
            borderRadius: 4,
            zIndex: 800,
            background: 'rgba(8, 19, 30, 0.5)',
            boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.5)',
        }),

        volume: volumeHeight => ({
            background: styleguide.colors['white'],
            width: 4,
            height: volumeHeight + 6,
            left: 13,
            top: 18,
            position: 'relative',
            cursor: 'pointer',
        }),

        bar: percent => ({
            position: 'absolute',
            width: '100%',
            height: '100%',
            transform: `scale(1, ${percent})`,
            transformOrigin: 'bottom left',
            bottom: 0,
            background: styleguide.colors['teal'],
        }),

        marker: {
            position: 'relative',
            left: 8,
            cursor: 'pointer',
            background: styleguide.colors['white'],
            width: 15,
            height: 15,
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
            ...styleguide.rounded,
        },
    },
}

class VolumeBar extends PureComponent {
    static propTypes = {
        theme: PropTypes.oneOf(['mobile', 'desktop']),
    }

    static defaultProps = {
        theme: 'mobile',
    }

    constructor(props) {
        super(props)

        const defaultVolumeHeight = (140 * window.innerHeight) / 854
        this.volumeHeight = this.props.volumeHeight || defaultVolumeHeight
        this.state = { volumePercentage: this.props.videoVolume ? this.props.videoVolume : 100 }
        this.R = {
            volume: undefined,
            marker: undefined,
        }
    }

    componentDidMount() {
        this.initPlayerVolume(this.props.volume)
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(this.props, nextProps)) {
            this.props.onChange && this.props.onChange()
            this.initPlayerVolume(this.props.volume)
        }
    }

    handleDrag = (e, ui) => {
        this.setVideoVolume(ui.y * -1)
    }

    handleVolumeClick = e => {
        const y = this.R.volume.getBoundingClientRect().bottom - e.pageY

        this.R.marker.setState({ y: -y })
        this.setVideoVolume(y)
    }

    handleClick = e => {
        e.stopPropagation()
    }

    initPlayerVolume = volume => {
        this.R.marker.setState({ y: (volume / 1) * -this.volumeHeight })
    }

    setVideoVolume = y => {
        const { onChange, setVideoVolume } = this.props
        onChange && onChange()
        const volume = Math.max(0, Math.min(y / this.volumeHeight, 1))
        const volumePercentage = volume * 100.0
        this.setState({ volumePercentage })
        setVideoVolume(volumePercentage)
    }

    render() {
        const { theme, style, volume } = this.props
        const percent = this.state.volumePercentage / 100.0
        return (
            <div style={style} onClick={this.handleClick}>
                <div style={Style[theme].volumeBarContainer(this.volumeHeight)}>
                    {/* Volume */}
                    <div
                        ref={c => {
                            this.R.volume = c
                        }}
                        style={Style[theme].volume(this.volumeHeight)}
                        onClick={this.handleVolumeClick}
                    >
                        {/* Bar */}
                        <div style={Style[theme].bar(percent)} />
                    </div>

                    {/* Marker */}
                    <Draggable
                        ref={c => (this.R.marker = c)}
                        axis="y"
                        handle=".marker"
                        onDrag={this.handleDrag}
                        defaultPosition={DRAGGABLE_DEFAULT_POSITION}
                        bounds={{ left: 0, top: -this.volumeHeight, right: 0, bottom: 0 }}
                    >
                        <div className="marker" style={Style[theme].marker} />
                    </Draggable>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ video }, { player }) => {
    return {
        // videoVolume: video.getIn(['videoVolume']),
        // player: video.getIn(['player']),
        // videoVolume: video.getIn(['videoVolume']),
        player,
    }
}

const mapDispatchToProps = (dispatch, getState) => {
    return {
        setVideoVolume: volume => dispatch(VideoPlayerActions.setVideoVolume(volume)),
    }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    setVideoVolume: volume => {
        dispatchProps.setVideoVolume(volume)
        stateProps.player.setVolume(volume / 100.0)
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(VolumeBar)
